import { z } from 'zod'

/* Turn off zod 4's JIT object parser.
 *
 * On the first object schema it builds, zod probes `new Function("")` to learn
 * whether code generation is allowed (`allowsEval` in zod/v4/core/util.js). The
 * throw is swallowed, but a strict CSP still REPORTS the attempt as a
 * `securitypolicyviolation` — «Evaluating a string as JavaScript violates
 * 'unsafe-eval'» on every page (N-29, #140), and an enforced policy would break
 * the probe's caller. Under `jitless` zod skips the probe and parses with its
 * interpreter, which is plenty for two small forms.
 *
 * This must run BEFORE any schema is constructed: zod reads the flag when an
 * object schema is built, not when it parses. `main.tsx` imports it first, and
 * its effect is pinned by `zodConfig.test.ts`. Do not remove the side effect
 * as an unused import. */
z.config({ jitless: true })
